import React from 'react'
import { Text as SonansText } from '@sonans/components'
import { Popup } from './Popup'

interface Props {
    children: React.ReactNode
    type?: 'title' | 'subtitle' | 'body'
    center?: boolean
    className?: string
    popupTitle?: string | React.ReactNode
    popupContent?: string | React.ReactNode
}

export function Text({
    children,
    type = 'body',
    center = false,
    className = '',
    popupTitle = '',
    popupContent,
}: Props) {
    const sizeMap = {
        title: 'headlineM',
        subtitle: 'headlineS',
        body: 'textL',
    } as const

    const extraClasses = [
        center ? 'text-center' : '',
        popupContent ? 'flex items-center gap-2' : '',
        className,
    ]
        .filter(Boolean)
        .join(' ')

    return (
        <SonansText size={sizeMap[type]} className={extraClasses}>
            {children}
            {popupContent && <Popup title={popupTitle} content={popupContent} />}
        </SonansText>
    )
}
